import React from 'react';
import { Box } from '@mui/material';
import RecommendationIcon from './RecommendationIcon';

function RecommendationIconGroup({
  storage = 0,
  chp = 0,
  fuel_cell = 0,
  solar = 0,
  pv = 0
}) {
  return (
    <Box className="recommendations" display="flex">
      <RecommendationIcon type="storage" value={storage} />
      <RecommendationIcon type="fuel_cell" value={fuel_cell} />
      <RecommendationIcon type="chp" value={chp} />
      <RecommendationIcon type="solar" value={solar || pv} />
    </Box>
  );
}

export default React.memo(RecommendationIconGroup);
